import { mapProductName } from '../address/Address'
import s from './PropertyListItem.module.scss'

type Props = {
  address: string
  postalCode: string
  city?: string
  product?: string
}

export const PropertyListItem = ({
  address,
  postalCode,
  city,
  product,
}: Props) => {
  return (
    <div className={s.propertyListItem}>
      <div>
        {address}, {postalCode} {city}
      </div>

      {product && mapProductName(product) && (
        <div className={s.propertyListItem__product}>
          {mapProductName(product)}
        </div>
      )}
    </div>
  )
}
